import React from "react";
import PropTypes from "prop-types";

import AppDialogueBox from "./AppDialogueBox";
import SlackMsg from "./SlackMsg";
import ChatBoxTextInput from "./ChatBoxTextInput";

const chatboxSections = [
    {
        header: "1 thing I'm feeling good about",
        responses: [
            {
                msgText: "@maja: So nice to be back! I've missed everyone"
            },
            {
                msgText:
                    "@jenny: Progress on 3things, and the new team direction!"
            },
            {
                msgText: "@poof:  everyone up in @here"
            }
        ]
    }
];

const chatBoxBody = sections => {
    const chatSection = sections.map((section, i) => {
        return (
            <div key={`chat-section-${i}`} className="chatbox__responses">
                <p className="chatbox__responses-header">{section.header}</p>
                {section.responses.map((response, i) => {
                    return <SlackMsg key={`msg-${i}`} {...response} />;
                })}
            </div>
        );
    });

    return chatSection;
};

const ChatBox = ({ channelName }) => (
    <div className="chatbox">
        <p className="chatbox__channel-name">#{channelName}</p>
        <AppDialogueBox
            bodyText="3things commenced by @jenny"
            className="chatbox__app-dialogue"
        />
        {chatBoxBody(chatboxSections)}
        <ChatBoxTextInput />
    </div>
);

ChatBox.propTypes = {
    channelName: PropTypes.string.isRequired
};

export default ChatBox;



// WEBPACK FOOTER //
// ./src/components/landingPage/ChatBox.jsx